import SettingsComponent from "../SettingsComponent.vue";

export default [
  {
    path: "/settings",
    name: "Settings",
    meta: { layout: "default" },
    component: SettingsComponent,
  },
];
